(function() {
  const CHECKMARK_SVG = '<svg width="12" height="12" viewBox="0 0 60.499 60.499" fill="#000000" xmlns="http://www.w3.org/2000/svg"><path d="M58.968,12.734c-2.193-2.423-5.936-2.608-8.359-0.415L24.481,35.975L9.991,22.218c-2.371-2.25-6.117-2.152-8.366,0.218 c-2.249,2.37-2.152,6.115,0.218,8.365l18.208,17.283c1.145,1.088,2.609,1.627,4.072,1.627c0.822,0,1.643-0.176,2.406-0.516 c0.885-0.232,1.729-0.674,2.455-1.332l29.568-26.771C60.976,18.899,61.161,15.157,58.968,12.734z"/></svg>';
  function setButtonAsAdded(btn) {
    if (!btn || btn.classList.contains("how-it-style-card__plus--added")) return;
    btn.disabled = true;
    btn.classList.add("how-it-style-card__plus--added");
    const icon = btn.querySelector(".how-it-style-card__plus-icon");
    if (icon) {
      icon.innerHTML = CHECKMARK_SVG;
    }
    const spinner = btn.querySelector(".loading__spinner");
    if (spinner) {
      spinner.remove();
    }
  }
  function updateButtonsByVariantId(variantId) {
    const forms = document.querySelectorAll(
      `.how-it-style-card__form[data-variant-id="${variantId}"]`
    );
    forms.forEach((form) => {
      const btn = form.querySelector(".how-it-style-card__plus");
      setButtonAsAdded(btn);
    });
  }
  document.addEventListener("product-ajax:added", () => {
    var _a, _b;
    const loadingBtn = document.querySelector(
      ".how-it-style-card__form .how-it-style-card__plus.btn--loading"
    );
    if (loadingBtn) {
      const form = loadingBtn.closest("form");
      const variantId = ((_a = form == null ? void 0 : form.dataset) == null ? void 0 : _a.variantId) || ((_b = form == null ? void 0 : form.querySelector('input[name="id"]')) == null ? void 0 : _b.value);
      if (variantId) {
        updateButtonsByVariantId(variantId);
      }
    }
  });
})();
const HOW_IT_STYLE_MQ = "(max-width: 989px)";
if (!customElements.get("how-it-style-carousel")) {
  customElements.define(
    "how-it-style-carousel",
    class HowItStyleCarousel extends HTMLElement {
      connectedCallback() {
        if (typeof FoxTheme === "undefined" || !FoxTheme.Carousel) return;
        this.selectors = {
          carouselWrap: ".how-style__carousel-wrap",
          grid: ".how-style__grid"
        };
        this.classes = {
          swiper: "swiper",
          swiperEqualHeight: "swiper-equal-height",
          swiperWrapper: "swiper-wrapper",
          swiperSlide: "swiper-slide"
        };
        this.carouselWrap = this.querySelector(this.selectors.carouselWrap);
        this.grid = this.querySelector(this.selectors.grid);
        this.controls = this.querySelector(".how-style__nav");
        this.items = this.grid ? Array.from(this.grid.querySelectorAll(".how-style__item")) : [];
        this.sliderInstance = false;
        if (!this.carouselWrap || !this.grid || this.items.length === 0) return;
        this.mql = window.matchMedia(HOW_IT_STYLE_MQ);
        this.onMqlChange = this.handleMqlChange.bind(this);
        this.mql.addEventListener("change", this.onMqlChange);
        this.handleMqlChange();
      }
      disconnectedCallback() {
        if (this.mql) {
          this.mql.removeEventListener("change", this.onMqlChange);
        }
        this.destroySlider();
      }
      handleMqlChange() {
        if (this.mql.matches) {
          this.initSlider();
        } else {
          this.destroySlider();
        }
      }
      initSlider() {
        if (typeof this.sliderInstance === "object") return;
        const columnGap = window.getComputedStyle(this.grid).getPropertyValue("--f-column-gap");
        const gapRem = parseFloat(columnGap.replace("rem", "")) || 1;
        const spaceBetween = gapRem * 10;
        this.sliderOptions = {
          slidesPerView: 2,
          spaceBetween,
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true
          }
        };
        const modules = [FoxTheme.Swiper.Mousewheel];
        if (this.controls) {
          this.sliderOptions.navigation = {
            nextEl: this.controls.querySelector(".swiper-button-next"),
            prevEl: this.controls.querySelector(".swiper-button-prev")
          };
          modules.push(FoxTheme.Swiper.Navigation);
        }
        this.items.forEach((item) => item.classList.add(this.classes.swiperSlide));
        this.carouselWrap.classList.add(this.classes.swiper, this.classes.swiperEqualHeight);
        this.grid.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(
          this.carouselWrap,
          this.sliderOptions,
          modules
        );
        this.sliderInstance.init();
        this.handleAccessibility();
      }
      handleAccessibility() {
        if (!this.sliderInstance || !this.sliderInstance.slider) return;
        const focusableElements = FoxTheme.a11y.getFocusableElements(this);
        focusableElements.forEach((element) => {
          element.addEventListener("focusin", (event) => {
            if (event.relatedTarget !== null) {
              const slide = element.closest(".swiper-slide");
              if (slide) {
                this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
              }
            } else {
              element.blur();
            }
          });
        });
      }
      destroySlider() {
        if (typeof this.sliderInstance === "object") {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
        this.items.forEach((item) => item.classList.remove(this.classes.swiperSlide));
        if (this.carouselWrap) {
          this.carouselWrap.classList.remove(this.classes.swiper, this.classes.swiperEqualHeight);
        }
        if (this.grid) {
          this.grid.classList.remove(this.classes.swiperWrapper);
        }
      }
    }
  );
}
